<template>
  <div v-show="qrCode_url == false" class="h-full">
    <div class="flex items-center justify-between w-full">
      <div class="flex flex-col font-mono text-g3 text-base">
        <span class="flex items-center">
          <svg
            class="w-[15px] fill-white mr-2 relative top-[-1px]"
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            viewBox="0 0 51.7 40.87"
          >
            <path
              class="cls-1"
              d="m47.14,13.3c-1.23,0-2.23,1.05-2.23,2.35s1,2.35,2.23,2.35,2.24-1.05,2.24-2.35-1-2.35-2.24-2.35Z"
            ></path>
            <path
              class="cls-1"
              d="m42.69,1.96v-.33c0-.9-.73-1.63-1.63-1.63h-12.16c-.9,0-1.63.73-1.63,1.63v.15H11.04C4.94,1.78,0,6.72,0,12.82v22.44c0,3.1,2.51,5.61,5.61,5.61h7.92v-3.89c0-.85.69-1.54,1.54-1.54h13.82s7.72-.01,7.72-.01c.85,0,1.54.69,1.54,1.54v3.89h8.02c3.05,0,5.53-2.47,5.53-5.53V12.83c0-5.41-3.88-9.9-9.01-10.87Zm-14.31-.23c0-.54.44-.97.97-.97h11.25c.54,0,.97.44.97.97v1.31c0,.54-.44.97-.97.97h-11.25c-.54,0-.97-.44-.97-.97v-1.31ZM5.08,37.78c-1.3,0-2.35-1.05-2.35-2.35s1.05-2.35,2.35-2.35,2.35,1.05,2.35,2.35-1.05,2.35-2.35,2.35Zm-.07-9.04h1.77c.36,0,.65.29.65.65v.59c0,.36-.29.65-.65.65h-1.77c-.36,0-.65-.29-.65-.65v-.59c0-.36.29-.65.65-.65Zm-.65-1.35v-.59c0-.36.29-.65.65-.65h1.77c.36,0,.65.29.65.65v.59c0,.36-.29.65-.65.65h-1.77c-.36,0-.65-.29-.65-.65Zm.28-7.46c-2.03,0-3.68-1.65-3.68-3.68s1.65-3.68,3.68-3.68,3.68,1.65,3.68,3.68-1.65,3.68-3.68,3.68Zm24.25,14.23H11.32v-.02c-.89,0-1.62-.73-1.62-1.63V10.12c0-.9.73-1.63,1.63-1.63h29.06c.9,0,1.63.73,1.63,1.63v22.41c0,.9-.73,1.63-1.63,1.63h-11.5Zm12.28,4.32c-.84,0-1.53-.68-1.53-1.53s.68-1.53,1.53-1.53,1.53.68,1.53,1.53-.68,1.53-1.53,1.53Zm5.59-10.75c0,.36-.29.65-.65.65h-1.77c-.36,0-.65-.29-.65-.65v-.59c0-.36.29-.65.65-.65h1.77c.36,0,.65.29.65.65v.59Zm0-2.59c0,.36-.29.65-.65.65h-1.77c-.36,0-.65-.29-.65-.65v-.59c0-.36.29-.65.65-.65h1.77c.36,0,.65.29.65.65v.59Zm.39-5.82c-2.03,0-3.68-1.65-3.68-3.68s1.65-3.68,3.68-3.68,3.68,1.65,3.68,3.68-1.65,3.68-3.68,3.68Z"
            ></path>
            <path
              class="cls-1"
              d="m36.37,36.36H15.26c-.51,0-.92.41-.92.92v3.58s.01.01.01.01h22.92v-.82s.02-.06.02-.1v-2.67c0-.51-.41-.92-.92-.92Z"
            ></path>
            <path
              class="cls-1"
              d="m4.63,13.91c-1.3,0-2.35,1.05-2.35,2.35s1.05,2.35,2.35,2.35,2.35-1.05,2.35-2.35-1.05-2.35-2.35-2.35Z"
            ></path>
          </svg>
          SN : {{ selectDevice.dev_sn }}
        </span>
        <span class="flex items-center">
          <svg
            class="w-[15px] fill-white mr-2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 21.215 21.334"
          >
            <g transform="translate(0 11)">
              <path
                d="M4.552.005a4.549,4.549,0,0,1,4.543,4.28l.008.268H7.57A3.018,3.018,0,1,0,4.326,7.56l.226.009V9.1a4.548,4.548,0,1,1,0-9.1Zm0,12.1v1.532A3.035,3.035,0,1,0,7.561,16.88l.009-.226H9.1a4.551,4.551,0,1,1-4.817-4.54l.267-.008Zm12.11,0a4.615,4.615,0,1,1-4.544,4.815l-.007-.268h1.532a3.018,3.018,0,1,0,3.244-3.006l-.226-.009V12.107Zm0-12.1a4.548,4.548,0,0,1,.267,9.088l-.267.008V7.569a3.035,3.035,0,1,0-3.009-3.241l-.009.226H12.111A4.549,4.549,0,0,1,16.661.005ZM16.867,15.8a.832.832,0,1,1-1.112.933,3.287,3.287,0,0,0-.518-.6c-.17-.173-.579-.473-1.046-.842a6.643,6.643,0,0,0-3.546-1.7A5.561,5.561,0,0,0,7.682,14.9c-.244.17-.712.523-1.324.98a4.078,4.078,0,0,0-.973,1.083l-.008-.008a.836.836,0,1,1-.958-1.183,1.806,1.806,0,0,0,.9-.639,19.84,19.84,0,0,0,1.265-1.6,5.379,5.379,0,0,0,1.283-2.788,4.843,4.843,0,0,0-1.186-2.7c-.212-.315-.667-.9-1.126-1.465A4.53,4.53,0,0,0,4.22,5.357l0,0a.833.833,0,1,1,1.233-.874,5.187,5.187,0,0,0,1.13,1.273s1.023.768,1.283.939a5.055,5.055,0,0,0,5.776-.106c.591-.485,1.589-1.25,1.589-1.25a2.432,2.432,0,0,0,.506-.755.837.837,0,1,1,1.189.8h0a2.413,2.413,0,0,0-.847.774s-.529.742-1.17,1.561a5.365,5.365,0,0,0-1.432,3.14,5.425,5.425,0,0,0,1.535,3.027,9.543,9.543,0,0,0,1.258,1.488,2.3,2.3,0,0,0,.588.427Z"
                transform="translate(0 -11.005)"
                fill="#fff"
                fill-rule="evenodd"
              ></path>
            </g>
          </svg>
          SN : {{ drone.dev_sn }}
        </span>
      </div>

      <div class="flex items-center">
        <button
          class="btn mr-6 h-[33px]"
          @click="qrCode_url = qrCode"
          v-if="qrCode !== false"
        >
          <svg
            class="fill-current w-[16px] relative"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64.47 63.8"
          >
            <path d="M0,29.64h29.64V0H0v29.64ZM6,6h17.64v17.64H6V6Z"></path>
            <rect x="9.15" y="9.15" width="11.33" height="11.33"></rect>
            <path
              d="M0,63.8h29.64v-29.64H0v29.64ZM6,40.17h17.64v17.64H6v-17.64Z"
            ></path>
            <path
              d="M34.83,0v29.64h29.64V0h-29.64ZM58.47,23.64h-17.64V6h17.64v17.64h0Z"
            ></path>
            <rect x="34.83" y="34.17" width="19.65" height="6.32"></rect>
            <rect x="34.83" y="43.32" width="6.32" height="20.48"></rect>
            <polygon
              points="57.74 53.56 49.99 53.56 49.99 57.49 43.49 57.49 43.49 63.8 50.65 63.8 50.65 59.88 57.3 59.88 57.3 63.8 64.47 63.8 64.47 57.49 57.74 57.49 57.74 53.56"
            ></polygon>
            <polygon
              points="58.15 43.16 46.82 43.16 46.82 49.48 58.15 49.48 58.65 49.48 64.47 49.48 64.47 34.17 58.15 34.17 58.15 43.16"
            ></polygon>
          </svg>
        </button>

        <button class="btn mr-2" @click="connection()">
          {{ $e("Connexion") }}
        </button>

        <button class="btn mr-2" @click="deconnection()">
          {{ $e("Déconnection") }}
        </button>

        <button
          class="btn flex items-center bg-g2 mr-4"
          @click="$emit('close')"
          :title="$e('Selectionner une autre RC')"
        >
          X
        </button>

        <slot></slot>
      </div>
    </div>

    <!-- <h2>
      #{{ drone.dev_id }} -
      {{ drone.dev_name }} :
      <span class="text-g3 text-base ml-4">
        {{ drone.dev_sn }}
      </span>
    </h2> -->
    <p
      class="text-error mt-4"
      v-if="
        status?.droneSn?.code != 615001 &&
        status?.droneSn?.data != selectDevice.dev_sn
      "
    >
      {{
        $e(`Le drone connecté à votre RC n'est pas celui enregistré dans le système de FlyingHub. Veuillez vous rendre
      sur l'application web pour modifier le drone attribué à votre télécommande.`)
      }}
    </p>

    <div
      class="flex overflow-x-auto max-h-dvh pb-4 h-full pr-1"
      v-if="openLog == false"
    >
      <div class="flex flex-col w-full">
        <div class="mt-8 grid grid-cols-5 gap-5 w-full">
          <div :class="gridCss + ' ' + dataCss(status?.mqttCharge?.data)">
            MQTT Chargé
          </div>
          <div :class="gridCss + ' ' + dataCss(status?.mqttConnecte?.data)">
            MQTT Connecté
          </div>

          <div :class="gridCss + ' ' + dataCss(status?.apiCharge?.data)">
            API Chargé
          </div>

          <div :class="gridCss + ' ' + dataCss(status?.mediaCharge?.data)">
            Media Chargé
          </div>

          <div :class="gridCss + ' ' + dataCss(status?.liveShareCharge?.data)">
            LiveShare Chargé
          </div>

          <div :class="gridCss + ' ' + dataCss(status?.wsCharge?.data)">
            WS Chargé
          </div>

          <div :class="gridCss + ' ' + dataCss(status?.wsConnection?.data)">
            WS Connecté
          </div>

          <div :class="gridCss + ' ' + dataCss(status?.tsaCharge?.data)">
            TSA Chargé
          </div>

          <div :class="gridCss + ' ' + dataCss(status?.mapCharge?.data)">
            Map Chargé
          </div>

          <div :class="gridCss + ' ' + dataCss(status?.missionCharge?.data)">
            Mission Chargé
          </div>

          <div
            :class="
              gridCss +
              ' !col-span-3 flex-wrap ' +
              dataLiveShare(status?.liveShareStatut)
            "
          >
            <template v-if="status?.liveShareStatut?.data == undefined">
              LiveShare Statut
            </template>
            <template v-else>
              <strong class="w-full mb-2"> LiveShare Statut : </strong>
              <template
                v-for="(item, index) in JSON.parse(status.liveShareStatut.data)"
                :key="index"
              >
                <div
                  class="mr-2 mb-1 bg-g0 w-max py-0.5 px-3 rounded-xl !text-white text-xs font-normal"
                >
                  {{ index }} :
                  {{ item }}
                </div>
              </template>
            </template>
          </div>

          <div
            :class="
              gridCss +
              ' !col-span-2 flex-wrap justify-center ' +
              datadroneSn(status?.droneSn)
            "
          >
            <template v-if="status?.liveShareStatut?.data == undefined">
              Drone
            </template>
            <template v-else-if="status?.droneSn?.code != 0">
              <strong class="w-full mb-0.5"> Drone : </strong>
              {{ status?.droneSn?.code }} -
              {{ status?.droneSn?.message }}
            </template>
            <template>
              <strong class="w-full mb-0.5"> Drone : </strong>
              {{ status?.droneSn?.data }}
            </template>
          </div>
        </div>

        <div class="w-full flex justify-end mt-10">
          <button class="text-[#3a3a3a] text-end" @click="openLog = !openLog">
            {{ openLog ? "Fermer" : "Logs" }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="openLog" class="flex flex-col justify-start">
      <div class="flex items-center mt-2">
        <button>
          <span @click="logClear" class="btn py-0.5 px-3 text-xs mr-6 bg-error">
            Effacer
          </span>
        </button>
        <button>
          <span @click="copy()" class="btn py-0.5 px-3 text-xs mr-6">
            Copier
          </span>
        </button>
        <button>
          <span
            @click="openLog = false"
            class="btn py-0.5 px-3 text-xs mr-6 bg-g3"
          >
            Fermer
          </span>
        </button>
      </div>

      <pre class="max-h-[250px] overflow-x-auto w-full mt-4">{{ msg }}</pre>
    </div>
  </div>

  <QrCode
    v-if="qrCode_url != false"
    :qrCode_url="qrCode_url"
    @close="qrCode_url = false"
  />
</template>

<script>
import { ref } from "vue";
import { toast } from "vue3-toastify";

import API from "@/utils/API";

import QrCode from "@/app/pilotlogin/DJI_RC_PLUS/template/QrCode.vue";

export default {
  name: "DJI_RC_PLUS_RC",
  props: {
    selectDevice: Object,
    sites: Array,
  },
  components: {
    QrCode,
  },
  emits: ["close"],
  setup() {
    return {
      gridCss:
        "w-full col-span-1 p-2 bg-g2 flex justify-center items-center text-center text-xs",
      msg: ref([]),
      idSettimer: ref(false),
      status: ref({}),
      deviceconnection: ref({}),
      openShare: ref(false),
      qrCode: ref(false),
      qrCode_url: ref(false),
      drone: ref({}),
      openLog: ref(false),
    };
  },

  mounted() {
    this.getDroneInfo();
    this.getStatus();
    this.idSettimer = setInterval(() => {
      this.getStatus();
    }, 5000);
  },

  unmounted() {
    clearInterval(this.idSettimer);
    this.deconnection();
  },

  methods: {
    async getDroneInfo() {
      if (this.selectDevice?.dev_family?.drone_dev_id == undefined) {
        let toast_config = { ...this.$root.toastConfig };
        toast_config.autoClose = false;

        toast.error(this.$e("Drone non défini"), toast_config);
        return;
      }

      this.drone = API.getFirstData(
        await API.get("device", {
          DevId: this.selectDevice.dev_family.drone_dev_id,
        })
      );

      this.qrCode =
        window.location.origin +
        "/flux/webrtc/" +
        this.drone.dev_sn +
        "/live2/";
    },

    log(msg) {
      this.msg.push(msg);
    },

    logClear() {
      this.msg = [];
    },

    async connection() {
      this.logClear();

      this.log("CONNEXION :");

      await $root.user.updateInfo();

      this.deviceconnection = await API.get("deviceconnection", {
        DevId: this.selectDevice.dev_id,
      });

      this.deviceconnection =
        this.deviceconnection["Cloud Service Configuration"];

      window.djiBridge.onBackClick = () => {
        return true;
      };

      /** ---- */

      this.log("D\u00e9claration du compte");

      window.djiBridge.platformVerifyLicense(
        "135786",
        "774f80506f1935e9bb02ef53689a032",
        "IalW8aYAlYQvSNcFfd9p2Kai1OPptGKTrmRekWqmMX/3Mev+vWZkNxem3uURXP7dGaaIpFoV3i/XpVY/ym8OvDF5bdkTKPGEavEt214nhAVEfq/Za22mipaI07NdppeBLiZvd3d5TWA7tichd5mfVxwhbacgwx6RTlCeex91e1c="
      );

      /** ---- */

      this.log("Module MQTT");

      var register_params = JSON.stringify({
        host: this.deviceconnection["MQTT gateway address"],
        connectCallback: () => {
          this.log(
            "Syst\u00e8me (mqtt) op\u00e9rationnel: " + Array.from(arguments)
          );
        },
        username: this.deviceconnection["MQTT account"],
        password: this.deviceconnection["MQTT password"],
      });

      window.djiBridge.platformLoadComponent("thing", register_params);
      this.log("Communication serveur MQTT");

      window.djiBridge.thingConnect(
        this.deviceconnection["MQTT account"],
        this.deviceconnection["MQTT password"],
        () => {
          this.log(
            "Syst\u00e8me (mqtt) op\u00e9rationnel: " + Array.from(arguments)
          );
        }
      );

      this.log("Module API");

      /** ---- */

      var register_params2 = JSON.stringify({
        host: window.location.origin + "/api/",
        token: this.selectDevice.dev_wsid,
      });

      window.djiBridge.platformLoadComponent("api", register_params2);

      var token = window.djiBridge.apiGetToken();

      this.log("Module Media");
      var register_params5 = JSON.stringify({
        autoUploadPhoto: true,
        autoUploadPhotoType: 0,
        autoUploadVideo: true,
      });
      window.djiBridge.platformLoadComponent("media", register_params5);

      /** ---- */

      this.log("Module WS");
      var register_params11 = JSON.stringify({
        host: "ws://" + window.location.host + "/ws/socket",
        token: this.selectDevice.dev_wsid,
        connectCallback: () => {
          this.log(
            "Syst\u00e8me (ws) op\u00e9rationnel: " + Array.from(arguments)
          );
        },
      });

      window.djiBridge.platformLoadComponent("ws", register_params11);

      /** ---- */

      this.log("Module TSA");
      var register_params12 = JSON.stringify({});
      window.djiBridge.platformLoadComponent("tsa", register_params12);

      /** ---- */

      this.log("Module Map");
      var register_params10 = JSON.stringify({
        userName: "uname",
        elementPreName: "prefName",
      });
      window.djiBridge.platformLoadComponent("map", register_params10);

      /** ---- */

      this.log("Module MISSION");
      var register_params13 = JSON.stringify({});
      window.djiBridge.platformLoadComponent("mission", register_params13);

      /** ---- */

      this.log("Module LiveShare.");
      var register_params3 = JSON.stringify({
        videoPublishType: "video-on-demand",
        statusCallback: "js_callback",
      });

      window.djiBridge.platformLoadComponent("liveshare", register_params3);

      var register_params4 = JSON.stringify({
        userName: "u1",
        password: "p1",
        port: 8554,
      });

      window.djiBridge.liveshareSetConfig(3, register_params4);
      window.djiBridge.liveshareStartLive();
      window.djiBridge.platformSetWorkspaceId(this.selectDevice.dev_wsid);
      window.djiBridge.platformSetWorkspaceId(this.selectDevice.dev_wsid);
      window.djiBridge.platformSetInformation(
        "Flying Eye",
        "Flying Eye",
        "1.3.9.6"
      );

      this.log("Chargements modules termin\u00e9s");

      this.getStatus();
    },

    deconnection() {
      this.logClear();

      this.log("DECONNEXION :");
      window.djiBridge.platformSetInformation("", "n/a", "");
      window.djiBridge.onBackClick = () => {
        return false;
      };
      window.djiBridge.platformUnloadComponent("liveshare");
      window.djiBridge.platformUnloadComponent("mission");
      window.djiBridge.platformUnloadComponent("map");
      window.djiBridge.platformUnloadComponent("tsa");
      window.djiBridge.platformUnloadComponent("ws");
      window.djiBridge.platformUnloadComponent("media");
      window.djiBridge.platformUnloadComponent("api");
      window.djiBridge.platformUnloadComponent("thing");
      this.log("D\u00e9connexion.");
    },

    getStatus() {
      if (navigator.userAgent.includes("DJI RC")) {
        // verif en plus pour permettre le debug via web
        this.status.compteVerifie = JSON.parse(
          window.djiBridge.platformIsVerified()
        );
        this.status.mqttCharge = JSON.parse(
          window.djiBridge.platformIsComponentLoaded("thing")
        );
        this.status.mqttConnecte = JSON.parse(
          window.djiBridge.thingGetConnectState()
        );
        this.status.apiCharge = JSON.parse(
          window.djiBridge.platformIsComponentLoaded("api")
        );
        this.status.mediaCharge = JSON.parse(
          window.djiBridge.platformIsComponentLoaded("media")
        );
        this.status.liveShareCharge = JSON.parse(
          window.djiBridge.platformIsComponentLoaded("liveshare")
        );
        this.status.liveShareStatut = JSON.parse(
          window.djiBridge.liveshareGetStatus()
        );
        this.status.wsCharge = JSON.parse(
          window.djiBridge.platformIsComponentLoaded("ws")
        );
        this.status.wsConnection = JSON.parse(
          window.djiBridge.wsGetConnectState()
        );
        this.status.tsaCharge = JSON.parse(
          window.djiBridge.platformIsComponentLoaded("tsa")
        );
        this.status.mapCharge = JSON.parse(
          window.djiBridge.platformIsComponentLoaded("map")
        );
        this.status.missionCharge = JSON.parse(
          window.djiBridge.platformIsComponentLoaded("mission")
        );
        this.status.plateformeVersion = JSON.parse(
          window.djiBridge.platformGetVersion()
        );
        this.status.rcSn = JSON.parse(
          window.djiBridge.platformGetRemoteControllerSN()
        );
        this.status.droneSn = JSON.parse(
          window.djiBridge.platformGetAircraftSN()
        );

        this.log("Status : " + JSON.stringify(this.status));
      }
    },

    dataCss(data) {
      if (data === undefined) return "bg-g2";
      else if (data === true) return "bg-success";
      else if (data === false) return "bg-error";
      else return "bg-g2";
    },

    dataLiveShare(el) {
      data = JSON.parse(el?.data ? el.data : "{}");
      if (data?.status === undefined) return "bg-g2";
      else if (data?.status === 0) return "bg-success";
      else if (data?.status !== 0) return "bg-error";
      else return "bg-g2";
    },

    datadroneSn(data) {
      if (data?.code == undefined) return "!bg-g2";
      else if (data?.code == 615001) return "!bg-error";
      else if (data?.code == 0) return "!bg-success";
      else if (data?.code != 0) return "!bg-warning";
      else return "!bg-g2";
    },

    getImage(device) {
      if (device?.det_id == undefined) return "default.png";
      return this.$root.device_image.hasOwnProperty(device.det_id)
        ? this.$root.device_image[device.det_id]
        : "default.png";
    },

    copy() {
      navigator.clipboard.writeText(this.msg.join("\n"));
      toast.success(this.$e("Texte copié"), this.$root.toastConfig);
    },
  },

  computed: {},
};
</script>
